import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=c202598e&scoped=true&"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=ts&"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=c202598e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c202598e",
  null
  
)

export default component.exports